"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import CircleLoader from "@/components/distribution-plan-tool/common/CircleLoader";
import { ReactQueryWrapperContext } from "@/components/react-query-wrapper/ReactQueryWrapper";
import UserRateAdjustmentHelper from "@/components/user/utils/rate/UserRateAdjustmentHelper";
import UserPageRateInput from "@/components/user/utils/rate/UserPageRateInput";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { getStringAsNumberOrZero } from "@/helpers/Helpers";
import { commonApiPost } from "@/services/api/common-api";
import { useMutation } from "@tanstack/react-query";
import { useContext, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { motion } from "framer-motion";
import { useClickAway, useKeyPressEvent } from "react-use";
import UserPageRepModifyModalHeader from "./UserPageRepModifyModalHeader";
import UserPageRepModifyModalRaterStats from "./UserPageRepModifyModalRaterStats";
import { useRepAllocation } from "@/hooks/useRepAllocation";
interface ApiAddRepRatingToProfileRequest {
  readonly amount: number;
  readonly category: string;
}
export default function UserPageRepModifyModal(t0) {
  const $ = _c(102);
  const {
    onClose,
    profile,
    category
  } = t0;
  const {
    onProfileRepModify
  } = useContext(ReactQueryWrapperContext);
  const {
    requestAuth,
    setToast,
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  let t1;
  if ($[0] !== category || $[1] !== profile) {
    t1 = {
      profile,
      category
    };
    $[0] = category;
    $[1] = profile;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    repState,
    heroAvailableRep,
    minMaxValues
  } = useRepAllocation(t1);
  const [adjustedRatingStr, setAdjustedRatingStr] = useState(`${repState?.rater_contribution ?? 0}`);
  let t2;
  if ($[3] !== repState?.rater_contribution) {
    t2 = () => {
      setAdjustedRatingStr(`${repState?.rater_contribution ?? 0}`);
    };
    $[3] = repState?.rater_contribution;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== repState) {
    t3 = [repState];
    $[5] = repState;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useEffect(t2, t3);
  const inputRef = useRef(null);
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    };
    t5 = [inputRef];
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  useEffect(t4, t5);
  const modalRef = useRef(null);
  useClickAway(modalRef, onClose);
  useKeyPressEvent("Escape", onClose);
  const [isMounted, setIsMounted] = useState(false);
  let t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setIsMounted(true);
    };
    t7 = [];
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  useEffect(t6, t7);
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [];
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  useEffect(_temp, t8);
  const adjustedValueNum = getStringAsNumberOrZero(adjustedRatingStr);
  const isValidValue = !!activeProfileProxy || adjustedValueNum >= minMaxValues.min && adjustedValueNum <= minMaxValues.max;
  let t9;
  if ($[12] !== adjustedRatingStr) {
    t9 = getStringAsNumberOrZero(adjustedRatingStr);
    $[12] = adjustedRatingStr;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const [newRating, setNewRating] = useState(t9);
  let t10;
  let t11;
  if ($[14] !== adjustedRatingStr) {
    t10 = () => {
      setNewRating(getStringAsNumberOrZero(adjustedRatingStr));
    };
    t11 = [adjustedRatingStr];
    $[14] = adjustedRatingStr;
    $[15] = t10;
    $[16] = t11;
  } else {
    t10 = $[15];
    t11 = $[16];
  }
  useEffect(t10, t11);
  const [haveChanged, setHaveChanged] = useState(newRating !== repState?.rater_contribution);
  let t12;
  if ($[17] !== newRating || $[18] !== repState?.rater_contribution) {
    t12 = () => {
      setHaveChanged(newRating !== repState?.rater_contribution);
    };
    $[17] = newRating;
    $[18] = repState?.rater_contribution;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== newRating || $[21] !== repState) {
    t13 = [newRating, repState];
    $[20] = newRating;
    $[21] = repState;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  useEffect(t12, t13);
  let t14;
  if ($[23] !== haveChanged || $[24] !== isValidValue || $[25] !== repState) {
    t14 = () => {
      if (!repState) {
        return true;
      }
      if (!haveChanged) {
        return true;
      }
      if (!isValidValue) {
        return true;
      }
      return false;
    };
    $[23] = haveChanged;
    $[24] = isValidValue;
    $[25] = repState;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  const getIsSaveDisabled = t14;
  const [isSaveDisabled, setIsSaveDisabled] = useState(getIsSaveDisabled());
  let t15;
  if ($[27] !== getIsSaveDisabled) {
    t15 = () => {
      setIsSaveDisabled(getIsSaveDisabled());
    };
    $[27] = getIsSaveDisabled;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== haveChanged || $[30] !== isValidValue || $[31] !== repState) {
    t16 = [haveChanged, isValidValue, repState];
    $[29] = haveChanged;
    $[30] = isValidValue;
    $[31] = repState;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  useEffect(t15, t16);
  const [mutating, setMutating] = useState(false);
  let t17;
  if ($[33] !== profile?.query) {
    t17 = async t18 => {
      const {
        amount,
        category: category_0
      } = t18;
      return await commonApiPost({
        endpoint: `profiles/${profile?.query}/rep/rating`,
        body: {
          amount,
          category: category_0
        }
      });
    };
    $[33] = profile?.query;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== activeProfileProxy || $[36] !== connectedProfile || $[37] !== onClose || $[38] !== onProfileRepModify || $[39] !== profile || $[40] !== setToast) {
    t18 = () => {
      setToast({
        message: "Rep updated.",
        type: "success"
      });
      onProfileRepModify({
        targetProfile: profile,
        connectedProfile,
        profileProxy: activeProfileProxy ?? null
      });
      onClose();
    };
    $[35] = activeProfileProxy;
    $[36] = connectedProfile;
    $[37] = onClose;
    $[38] = onProfileRepModify;
    $[39] = profile;
    $[40] = setToast;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== setToast) {
    t19 = error => {
      setToast({
        message: error as unknown as string,
        type: "error"
      });
    };
    $[42] = setToast;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  let t20;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = () => {
      setMutating(false);
    };
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== t17 || $[46] !== t18 || $[47] !== t19) {
    t21 = {
      mutationFn: t17,
      onSuccess: t18,
      onError: t19,
      onSettled: t20
    };
    $[45] = t17;
    $[46] = t18;
    $[47] = t19;
    $[48] = t21;
  } else {
    t21 = $[48];
  }
  const addRepMutation = useMutation(t21);
  let t22;
  if ($[49] !== addRepMutation || $[50] !== category || $[51] !== haveChanged || $[52] !== mutating || $[53] !== newRating || $[54] !== requestAuth || $[55] !== setToast) {
    t22 = async event => {
      event.preventDefault();
      if (mutating) {
        return;
      }
      setMutating(true);
      const {
        success
      } = await requestAuth();
      if (!success) {
        setToast({
          message: "You must be logged in.",
          type: "error"
        });
        setMutating(false);
        return;
      }
      if (!haveChanged) {
        setMutating(false);
        return;
      }
      await addRepMutation.mutateAsync({
        amount: newRating,
        category
      });
    };
    $[49] = addRepMutation;
    $[50] = category;
    $[51] = haveChanged;
    $[52] = mutating;
    $[53] = newRating;
    $[54] = requestAuth;
    $[55] = setToast;
    $[56] = t22;
  } else {
    t22 = $[56];
  }
  const onSubmit = t22;
  if (!isMounted || globalThis.document === undefined) {
    return null;
  }
  let t23;
  let t24;
  let t25;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = {
      opacity: 0
    };
    t24 = {
      opacity: 1
    };
    t25 = {
      opacity: 0
    };
    $[57] = t23;
    $[58] = t24;
    $[59] = t25;
  } else {
    t23 = $[57];
    t24 = $[58];
    t25 = $[59];
  }
  let t26;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <div className="tw-absolute tw-inset-0 tw-bg-gray-600 tw-bg-opacity-50 tw-backdrop-blur-[1px]" />;
    $[60] = t26;
  } else {
    t26 = $[60];
  }
  const t27 = profile.query ?? profile.handle ?? profile.display;
  let t28;
  if ($[61] !== onClose || $[62] !== t27) {
    t28 = <UserPageRepModifyModalHeader handleOrWallet={t27} onClose={onClose} />;
    $[61] = onClose;
    $[62] = t27;
    $[63] = t28;
  } else {
    t28 = $[63];
  }
  let t29;
  if ($[64] !== heroAvailableRep || $[65] !== minMaxValues || $[66] !== repState) {
    t29 = repState && <UserPageRepModifyModalRaterStats repState={repState} minMaxValues={minMaxValues} heroAvailableCredit={heroAvailableRep} />;
    $[64] = heroAvailableRep;
    $[65] = minMaxValues;
    $[66] = repState;
    $[67] = t29;
  } else {
    t29 = $[67];
  }
  let t30;
  if ($[68] !== category) {
    t30 = <label className="tw-block tw-text-sm tw-font-normal tw-leading-5 tw-text-iron-400">Your total Rep for {category}:</label>;
    $[68] = category;
    $[69] = t30;
  } else {
    t30 = $[69];
  }
  const t31 = !!activeProfileProxy;
  let t32;
  if ($[70] !== adjustedRatingStr || $[71] !== minMaxValues || $[72] !== t31) {
    t32 = <div className="tw-relative tw-flex tw-mt-1.5"><UserPageRateInput value={adjustedRatingStr} onChange={setAdjustedRatingStr} minMax={minMaxValues} isProxy={t31} inputRef={inputRef} required={true} /></div>;
    $[70] = adjustedRatingStr;
    $[71] = minMaxValues;
    $[72] = t31;
    $[73] = t32;
  } else {
    t32 = $[73];
  }
  const t33 = repState?.rater_contribution ?? 0;
  let t34;
  if ($[74] !== adjustedRatingStr) {
    t34 = getStringAsNumberOrZero(adjustedRatingStr);
    $[74] = adjustedRatingStr;
    $[75] = t34;
  } else {
    t34 = $[75];
  }
  let t35;
  if ($[76] !== t33 || $[77] !== t34) {
    t35 = <UserRateAdjustmentHelper inLineValues={true} originalValue={t33} adjustedValue={t34} adjustmentType="Rep" />;
    $[76] = t33;
    $[77] = t34;
    $[78] = t35;
  } else {
    t35 = $[78];
  }
  let t36;
  if ($[79] !== t30 || $[80] !== t32 || $[81] !== t35) {
    t36 = <div>{t30}{t32}{t35}</div>;
    $[79] = t30;
    $[80] = t32;
    $[81] = t35;
    $[82] = t36;
  } else {
    t36 = $[82];
  }
  const t37 = `${!isSaveDisabled ? "tw-cursor-pointer hover:tw-bg-primary-600 hover:tw-border-primary-600" : "tw-cursor-not-allowed tw-opacity-50"} tw-w-full sm:tw-w-auto tw-bg-primary-500 tw-border-primary-500 tw-px-4 tw-py-3 tw-text-sm tw-font-semibold tw-text-white tw-border tw-border-solid  tw-rounded-lg  tw-transition tw-duration-300 tw-ease-out`;
  let t38;
  if ($[83] !== mutating) {
    t38 = mutating ? <div className="tw-w-8"><CircleLoader /></div> : <>Save</>;
    $[83] = mutating;
    $[84] = t38;
  } else {
    t38 = $[84];
  }
  let t39;
  if ($[85] !== isSaveDisabled || $[86] !== t37 || $[87] !== t38) {
    t39 = <button type="submit" disabled={isSaveDisabled} className={t37}>{t38}</button>;
    $[85] = isSaveDisabled;
    $[86] = t37;
    $[87] = t38;
    $[88] = t39;
  } else {
    t39 = $[88];
  }
  let t40;
  if ($[89] !== onClose) {
    t40 = <button onClick={onClose} type="button" className="tw-mt-3 sm:tw-mt-0 tw-w-full sm:tw-w-auto tw-cursor-pointer tw-bg-iron-900 tw-px-4 tw-py-3 tw-text-sm tw-font-semibold tw-text-white tw-border tw-border-solid tw-border-iron-700 tw-rounded-lg hover:tw-bg-iron-800 tw-transition tw-duration-300 tw-ease-out">Cancel</button>;
    $[89] = onClose;
    $[90] = t40;
  } else {
    t40 = $[90];
  }
  let t41;
  if ($[91] !== t39 || $[92] !== t40) {
    t41 = <div className="tw-mt-8"><div className="sm:tw-flex sm:tw-flex-row-reverse tw-gap-x-3">{t39}{t40}</div></div>;
    $[91] = t39;
    $[92] = t40;
    $[93] = t41;
  } else {
    t41 = $[93];
  }
  let t42;
  if ($[94] !== onSubmit || $[95] !== t36 || $[96] !== t41) {
    t42 = <form onSubmit={onSubmit} className="tw-mt-4">{t36}{t41}</form>;
    $[94] = onSubmit;
    $[95] = t36;
    $[96] = t41;
    $[97] = t42;
  } else {
    t42 = $[97];
  }
  let t43;
  if ($[98] !== t28 || $[99] !== t29 || $[100] !== t42) {
    t43 = createPortal(<motion.div initial={t23} animate={t24} exit={t25} className="tailwind-scope tw-fixed tw-inset-0 tw-z-[1100] tw-cursor-default">{t26}<div className="tw-relative tw-flex tw-min-h-full tw-w-full tw-overflow-y-auto tw-items-end tw-justify-center tw-text-center sm:tw-items-center tw-p-2 lg:tw-p-0"><div ref={modalRef} className="sm:tw-max-w-md tw-relative tw-w-full tw-transform tw-rounded-xl tw-bg-iron-950 tw-text-left tw-shadow-xl tw-transition-all tw-duration-500 sm:tw-w-full tw-p-6">{t28}{t29}{t42}</div></div></motion.div>, document.body);
    $[98] = t28;
    $[99] = t29;
    $[100] = t42;
    $[101] = t43;
  } else {
    t43 = $[101];
  }
  return t43;
}
function _temp() {
  if (globalThis.document === undefined || globalThis.window === undefined) {
    return;
  }
  const currentWindow = globalThis.window;
  const previousOverflow = document.body.style.overflow;
  const previousPaddingRight = document.body.style.paddingRight;
  const scrollbarGap = currentWindow.innerWidth - document.documentElement.clientWidth;
  document.body.style.overflow = "hidden";
  if (scrollbarGap > 0) {
    document.body.style.paddingRight = `${scrollbarGap}px`;
  }
  return () => {
    document.body.style.overflow = previousOverflow;
    document.body.style.paddingRight = previousPaddingRight;
  };
}